import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Share from './Share';

ReactDOM.render(<Share />, document.getElementById('root'));

